import type { IconProps } from './types';
import './icons.css';

export default function SidepanelUnexpand({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      className={`icon icon-sidepanel-unexpand ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M18.154 3.004A3 3 0 0 1 21 6v12l-.004.154a3 3 0 0 1-2.842 2.842L18 21H6l-.154-.004a3 3 0 0 1-2.842-2.841L3 18V6a3 3 0 0 1 2.846-2.996L6 3h12l.154.004ZM6 4.5A1.5 1.5 0 0 0 4.5 6v12A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 18 4.5H6ZM17 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6Z"
      />
    </svg>
  );
}
